import Button from "components/utils/Button";
import { useTranslation } from "react-i18next";

function Hero() {

	const { t } = useTranslation();

	return (
		<div className="hero bg-gray-900 pb-10 hero-scroll-background">
			<div className="container flex w-full">
				<div className="content mt-16">
					<h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold">
						<span className="text-white">{ t("mainPage.hero.title.part1") }</span>
						<span className="ml-3 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-purple-600">{ t("mainPage.hero.title.part2") }</span>
					</h1>
					<p className="text-stone-50 text-lg font-light w-full md:w-2/3 my-10">
						{ t("mainPage.hero.description") }
					</p>
					<Button link="/about-us">
						{ t("mainPage.hero.buttonText") }
					</Button>
				</div>
			</div>
		</div>
	);
}

export default Hero;